function normalize(s) {
  return String(s ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9 ]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function levenshtein(a, b) {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  const dp = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i++) {
    let prev = dp[0];
    dp[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const tmp = dp[j];
      dp[j] = a[i - 1] === b[j - 1]
        ? prev
        : 1 + Math.min(prev, dp[j - 1], dp[j]);
      prev = tmp;
    }
  }
  return dp[b.length];
}

const MIN_AFFIX_LEN = 3;

export function fuzzyScore(a, b) {
  const na = normalize(a);
  const nb = normalize(b);
  if (!na || !nb) return 0;
  if (na === nb) return 1;

  const [shorter, longer] = na.length <= nb.length ? [na, nb] : [nb, na];

  if (shorter.length >= MIN_AFFIX_LEN) {
    if (longer.startsWith(shorter)) {
      return 0.85 + 0.1 * (shorter.length / longer.length);
    }
    if (longer.endsWith(shorter)) {
      return 0.8 + 0.1 * (shorter.length / longer.length);
    }
    if (longer.includes(shorter)) {
      return 0.75 + 0.1 * (shorter.length / longer.length);
    }
  }

  const maxLen = Math.max(na.length, nb.length);
  return 1 - levenshtein(na, nb) / maxLen;
}

export function findClosestDomain(value, domain, options = {}) {
  if (!Array.isArray(domain) || domain.length === 0) return null;
  if (value === null || value === undefined || value === '') return null;
  const threshold = options.threshold ?? 0.7;
  const str = String(value);
  let best = null;
  let bestScore = 0;
  for (const entry of domain) {
    const k = entry.key != null ? String(entry.key) : '';
    const v = entry.value != null ? String(entry.value) : '';
    const score = Math.max(
      k ? fuzzyScore(str, k) : 0,
      v ? fuzzyScore(str, v) : 0,
    );
    if (score > bestScore) {
      best = entry;
      bestScore = score;
    }
  }
  if (best && bestScore >= threshold) {
    return { key: best.key, value: best.value, score: bestScore };
  }
  return null;
}
